<script setup>
import { RouterView } from 'vue-router';

const heroUrl = 'https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?w=1800&fit=crop&q=70&auto=format';
</script>

<template>
  <div class="min-h-screen flex bg-(--admin-canvas)">
    <!-- Sol: tam ekran otel fotoğrafı -->
    <aside class="hidden lg:block flex-1 relative overflow-hidden min-w-0">
      <img :src="heroUrl" alt="" class="absolute inset-0 w-full h-full object-cover" />
      <div
        class="absolute inset-0"
        style="background: linear-gradient(to top, rgba(9,17,38,.55), rgba(9,17,38,0) 45%);"
      />
      <div class="absolute left-9 bottom-8 text-white">
        <p class="font-display italic text-2xl font-medium whitespace-nowrap lowercase">türk rivierası'nın seçkin adresleri</p>
        <p class="text-[11px] uppercase tracking-[0.14em] font-semibold opacity-75 mt-1">VIP Travellers Koleksiyonu</p>
      </div>
    </aside>

    <!-- Sağ: kompakt giriş paneli -->
    <main class="w-full lg:w-[480px] shrink-0 flex items-center justify-center px-6 py-12">
      <div class="w-full max-w-[352px]">
        <RouterView />
      </div>
    </main>
  </div>
</template>
